import React from "react";
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography } from "@mui/material";
import Btn from "../../common/Button/Button";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import BottomWhenModal from "./BottomWhenModal";

export default function BottomFilterModalAuction({ open, toggleDrawer }) {
  const [bottomWhenModal, setBottomWhenModal] = React.useState(false);
  const toggleWhenModal = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setBottomWhenModal(open);
  };
  const [selectedWhen, setSelectedWhen] = React.useState("");
  const handleSelectedWhen = (str) => {
    setSelectedWhen(str);
  };
  const [tabValue, setTabValue] = React.useState(0);
  const clearAll = () => {
    setTabValue(0);
    setSelectedWhen("");
  };
  const handleChange = (_, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={toggleDrawer(false)}
      PaperProps={{
        sx: {
          height: "100%",
          boxShadow:
            "0px -8px 10px rgba(0, 0, 0, 0.14), 0px -3px 14px rgba(0, 0, 0, 0.12), 0px -5px 5px rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <div
        style={{ overflowY: "scroll", height: "100%", position: "relative" }}
      >
        <Box
          sx={{
            paddingTop: "28px",
            marginBottom: "24px",
            paddingX: "16px",
            display: "flex",
            flexDirection: "column",

            width: "100%",
            backgroundColor: "white",
            zIndex: "10",
          }}
        >
          <Box
            sx={{
              marginBottom: "16px",
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <CloseIcon
              onClick={toggleDrawer(false)}
              sx={{
                marginLeft: "2px",
                "&:hover": {
                  cursor: "pointer",
                },
              }}
            />
            <Typography
              fontWeight="600"
              fontSize="16px"
              lineHeight="24px"
              color="text.primary"
              sx={{ textDecoration: "underline" }}
              onClick={clearAll}
            >
              Clear All
            </Typography>
          </Box>
          <Typography
            variant="h3"
            fontWeight="600"
            fontSize="22px"
            lineHeight="26px"
            color="text.primary"
          >
            Filters
          </Typography>
        </Box>
        <Box sx={{ paddingX: "16px" }}>
          <Heading text="Type" />
          <Box sx={{ display: "flex", columnGap: "8px" }}>
            <Btn
              variant="outlined"
              onClick={(e) => handleChange(e, 0)}
              bgColor={tabValue === 0 ? "#255CCE1A" : "#F5F5F5"}
              outColor={tabValue === 0 ? "#255CCE" : "#FFF"}
              sx={{
                maxWidth: "auto",
                height: "36px",
                padding: "6px 16px",
              }}
              size="lg"
              txColor="text.primary"
              typoVariant="body1"
              fontWeight="400"
            >
              Online Auction
            </Btn>
            <Btn
              variant="outlined"
              onClick={(e) => handleChange(e, 1)}
              bgColor={tabValue === 1 ? "#255CCE1A" : "#F5F5F5"}
              outColor={tabValue === 1 ? "#255CCE" : "#FFF"}
              sx={{
                maxWidth: "auto",
                height: "36px",
                padding: "6px 8px",
              }}
              size="lg"
              txColor="text.primary"
              typoVariant="body1"
              fontWeight="400"
            >
              On Site Auction
            </Btn>
          </Box>
          <Line />
          <CloseBy
            head="When"
            label="Chose date to filter"
            selected={selectedWhen}
            onClick={toggleWhenModal(true)}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.8)",
            zIndex: "1000",
            position: "absolute",
            bottom: "0%",
            backgroundColor: "#fff",
          }}
        >
          <Btn
            variant="contained"
            size="lg"
            txColor="text.primary"
            bgColor="#F9D548"
            sx={{
              margin: "16px",
              height: "48px",
              width: "343px",
              boxShadow: "none",
            }}
            onClick={toggleDrawer(false)}
            hoverBg="#F3C04F"
          >
            Search
          </Btn>
        </Box>
      </div>
      <BottomWhenModal
        open={bottomWhenModal}
        toggleDrawer={toggleWhenModal}
        setSelectedWhen={handleSelectedWhen}
      />
    </Drawer>
  );
}

function CloseBy({ head, label, onClick, selected }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box>
        <Typography
          variant="subtitle1"
          fontWeight="600"
          fontSize="16px"
          lineHeight="24px"
          color="text.primary"
          sx={{ marginBottom: "4px" }}
        >
          {head}
        </Typography>
        <Typography
          variant="body1"
          fontFamily="Inter"
          fontSize="16px"
          fontWeight="400"
          lineHeight="24px"
          color={selected !== "" ? "primary.main" : "#616161"}
        >
          {selected !== "" ? selected.toString() : label}
        </Typography>
      </Box>
      <ChevronRightIcon sx={{ color: "#616161" }} />
    </Box>
  );
}

function Heading({ text, margin = "8" }) {
  return (
    <Typography
      variant="subtitle1"
      fontWeight="600"
      fontSize="16px"
      lineHeight="24px"
      color="text.primary"
      sx={{ marginBottom: `${margin}px` }}
    >
      {text}
    </Typography>
  );
}

function Line() {
  return (
    <Box
      sx={{
        marginY: "24px",
        width: "100%",
        height: "1px",
        backgroundColor: "#D6D6D6",
      }}
    ></Box>
  );
}
